import { Button } from '@mui/material'

// Types
import type { TextButtonProps } from '@/types/components/atoms/button/text'

const TextButtonAtom = (props: TextButtonProps) => {
	// Props
	const { text, type, loading, size, color, startIcon, disabled, onClick } = props

	return (
		<Button
			variant="text"
			type={type}
			loading={loading}
			loadingPosition="start"
			size={size}
			color={color}
			disabled={disabled}
			startIcon={startIcon}
			disableElevation
			onClick={onClick}
			sx={{
				color: 'text.primary',
				lineHeight: 1,
				...(size === 'small' && { fontSize: 16 }),
				...(size === 'medium' && { fontSize: 20 }),
				...(size === 'large' && { fontSize: 24 }),
				'& .MuiButton-startIcon': { color: 'primary.main' }
			}}
		>
			{text}
		</Button>
	)
}

export default TextButtonAtom
